import axios from 'axios'
import { propertyListDataType } from './LeadManagementDataTypes'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const LIST_LEAD_FORMS = `${LOCAL_URL}/leads/listLeadForms`
export const LIST_LEAD = `${LOCAL_URL}/leads/listLeads`
export const PROPERTY_UPDATE = `${LOCAL_URL}/leads/leadPropertyUpdate`
export const SCHEDULE_VISIT = `${LOCAL_URL}/leads/leadPropertySchedule`
export const LEAD_PROPERTY_STATUS = `${LOCAL_URL}/leads/leadPropertyStatus`
export const LEAD_STATS = `${LOCAL_URL}/leads/leadStats`
export const ADD_LEAD = `${LOCAL_URL}/leads/leadAdd`
export const LEAD_STATUS_UPDATE = `${LOCAL_URL}/leads/leadStatusUpdate`
export const GEN_LEAD_FORMID = `${LOCAL_URL}/leads/genLeadFormID`
export const ADD_BOOKING_LEAD_AMOUNT = `${LOCAL_URL}/leads/addBookingLeadAmount`
export const GEN_LEAD_PAYMENT = `${LOCAL_URL}/leads/genLeadPayment`
export const GEN_LEAD_PAYMENT_WHATSAPP = `${LOCAL_URL}/leads/genLeadPayment/whatsapp`
const headers = {
  Authorization: API_TOKEN,
}

// function to get list lead form link(Jotform link)
export async function getListLeadForm() {
  return await axios.get(LIST_LEAD_FORMS, { headers })
}

// function to get list of leads
export async function getListLead(offset: number, limit: number, search: string) {
  return await axios.post(LIST_LEAD, { offset, limit, search })
}

// function to update the properties for the leads
export async function propertyUpdate(leads_data_uuid: string, properties: propertyListDataType[]) {
  return await axios.post(PROPERTY_UPDATE, { leads_data_uuid, properties })
}

// function to schedule visit for the property visit for leads
export async function scheduleVisit(leads_property_uuid: string, scheduled_visit_date: string) {
  return await axios.post(SCHEDULE_VISIT, { leads_property_uuid, scheduled_visit_date })
}

// function to update the property status for leads
export async function leadPropertyStatus(
  leads_property_uuid: string,
  leads_property_status: number,
  customer_feedback: string = ''
) {
  return await axios.post(LEAD_PROPERTY_STATUS, {
    leads_property_uuid,
    leads_property_status,
    customer_feedback,
  })
}

// function to get lead dashboard stats
export async function leadStats() {
  return await axios.get(LEAD_STATS)
}

// function to add the leads
export async function addLead(
  full_name: string, //mandetory
  phone_number: string, //mandetory
  email: string, //mandetory
  contact_mode: string, //mandetory
  address_1: string = '',
  address_2: string = '',
  city: string = '',
  state: string = '',
  pincode: string = '',
  property_type: string = '',
  prefferd_loc: string = '',
  no_room: number | string = '',
  no_toilet: number | string = '',
  min_price: number | string = '',
  max_price: number | string = '',
  pet_friendly: string = '',
  tenancy_period: string = '',
  tenancy_start: string = '',
  employment_type: string = '',
  employment_length: string = '',
  monthly_income: string = '',
  other_requirement: string = '',
  current_employer: string = '',
  business_name: string = ''
) {
  return await axios.post(ADD_LEAD, {
    full_name,
    phone_number,
    email,
    contact_mode,
    address_1,
    address_2,
    city,
    state,
    pincode,
    property_type,
    prefferd_loc,
    no_room,
    no_toilet,
    min_price,
    max_price,
    pet_friendly,
    tenancy_period,
    tenancy_start,
    employment_type,
    employment_length,
    monthly_income,
    other_requirement,
    current_employer,
    business_name,
  })
}

// function to update the lead's status
export async function leadStatusUpdate(leads_data_uuid: string, leads_data_status: number) {
  return await axios.post(LEAD_STATUS_UPDATE, { leads_data_uuid, leads_data_status })
}

// function to update the lead's status
export async function generateLeadFormID(leads_property_uuid: string) {
  return await axios.post(GEN_LEAD_FORMID, { leads_property_uuid })
}

// function to add the booking amount for the leads
export async function addBookingAmount(lead_property_booking_uuid: string, amount: number) {
  return await axios.post(ADD_BOOKING_LEAD_AMOUNT, { lead_property_booking_uuid, amount })
}

// function to generate payment link for lead booking
export async function generatePaymentLink(lead_property_booking_uuid: string) {
  return await axios.post(GEN_LEAD_PAYMENT, { lead_property_booking_uuid })
}

export async function sendWhatsappPaymentLink(lead_property_booking_uuid: string) {
  return await axios.post(GEN_LEAD_PAYMENT_WHATSAPP, { lead_property_booking_uuid })
}